export { default as PermMediaOutlinedIcon } from "@mui/icons-material/PermMediaOutlined";
